var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.31,
    height: 18.31,
    viewBox: "0 0 18.31 18.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "translate(-1.875 -1.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6234",
    "data-name": "Path 6234",
    d: "M15.549,21.17H7.9a2.16,2.16,0,0,1-2.156-1.952L4.5,6.794A.721.721,0,0,1,5.222,6h13a.722.722,0,0,1,.719.794L17.705,19.217a2.161,2.161,0,0,1-2.156,1.953ZM6.02,7.445l1.16,11.63a.721.721,0,0,0,.719.651h7.65a.721.721,0,0,0,.719-.651l1.16-11.63Z",
    transform: "translate(-0.694 -1.11)",
    fill: "#c0c7cc",
    stroke: "#c0c7cc",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6235",
    "data-name": "Path 6235",
    d: "M19.337,7.445H2.722A.722.722,0,1,1,2.722,6H19.337a.722.722,0,1,1,0,1.445Z",
    transform: "translate(0 -1.11)",
    fill: "#c0c7cc",
    stroke: "#c0c7cc",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6236",
    "data-name": "Path 6236",
    d: "M14.222,19.391a.722.722,0,0,1-.722-.722V10.722a.722.722,0,0,1,1.445,0v7.946A.722.722,0,0,1,14.222,19.391Z",
    transform: "translate(-3.193 -2.221)",
    fill: "#c0c7cc",
    stroke: "#c0c7cc",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6237",
    "data-name": "Path 6237",
    d: "M10.444,19.391a.722.722,0,0,1-.719-.657L9,10.787a.722.722,0,1,1,1.439-.13l.722,7.946a.722.722,0,0,1-.72.787Z",
    transform: "translate(-1.943 -2.221)",
    fill: "#c0c7cc",
    stroke: "#c0c7cc",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6238",
    "data-name": "Path 6238",
    d: "M17.723,19.391A.722.722,0,0,1,17,18.6l.722-7.946a.722.722,0,1,1,1.439.13l-.722,7.946A.722.722,0,0,1,17.723,19.391Z",
    transform: "translate(-4.164 -2.221)",
    fill: "#c0c7cc",
    stroke: "#c0c7cc",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6239",
    "data-name": "Path 6239",
    d: "M16.224,6.334h-6.5A.722.722,0,0,1,9,5.612V2.722A.722.722,0,0,1,9.722,2h6.5a.722.722,0,0,1,.722.722v2.89A.722.722,0,0,1,16.224,6.334ZM10.445,4.89H15.5V3.445H10.445Z",
    transform: "translate(-1.943)",
    fill: "#c0c7cc",
    stroke: "#c0c7cc",
    strokeWidth: 0.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.71a52d8c34e07851f437d95abeef46f5.svg";
export { ForwardRef as ReactComponent };